import { render, staticRenderFns } from "./Input.vue?vue&type=template&id=1989f9ad&scoped=true&"
import script from "./Input.vue?vue&type=script&lang=js&"
export * from "./Input.vue?vue&type=script&lang=js&"
import style0 from "./Input.vue?vue&type=style&index=0&id=1989f9ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1989f9ad",
  null
  
)

export default component.exports